import moment from "moment";
import { Card, Col, Row } from "react-bootstrap";
import { useGetClientSummaryDetails } from "../hooks/useGetClientSummaryDetails";
import Skeleton from "react-loading-skeleton";

function PortfolioValuationSummaryDetails() {
    const today = new Date();
    const { data, error, isLoading } = useGetClientSummaryDetails();

    if (isLoading) return (
        <Skeleton height={300} />
    )

    if (error) return <p>Error loading data</p>;
    if (!data) {
        return null;
    }

    const isYesterday = (e) => {
        return moment(e).isSame(moment().subtract(1, 'days'), 'day');
    };

    const valuationData = data ? (() => {
        const valuationDifference = data.portfolioValue - data.previousPortfolioValue;
        const valuationPercentageDifference = data.previousPortfolioValue !== 0 ? parseFloat(((valuationDifference / data.previousPortfolioValue) * 100).toFixed(2)) : null;

        let valuationDifferenceMessage = '';
        if (valuationDifference > 0) {
            valuationDifferenceMessage = 'Up ' + valuationPercentageDifference + '% since previous valuation on ' + moment(data.previousPortfolioValueDate).format('Do MMMM YYYY');
        }
        else if (valuationDifference == 0) {
            if (data.previousPortfolioValueDate != null && isYesterday(data.previousPortfolioValueDate)) {
                valuationDifferenceMessage = 'No change since previous valuation yesterday';
            }
            else if (data.previousPortfolioValueDate != null) {
                valuationDifferenceMessage = 'No change since previous valuation on ' + moment(data.previousPortfolioValueDate).format('Do MMMM YYYY');
            }
            else {
                valuationDifferenceMessage = 'No change to current valuation';
            }
        }
        else if (valuationDifference < 0) {
            valuationDifferenceMessage = 'Down ' + Math.abs(valuationPercentageDifference).toFixed(2) + '% since previous valuation on ' + moment(data.previousPortfolioValueDate).format('Do MMMM YYYY');
        }

        let valuationPercentageDifferenceMessage = '';
        let valuationPercentageDifferenceMessageStyle = { color: 'purple', fontSize: "16px" };
        if (valuationPercentageDifference > 0) {
            valuationPercentageDifferenceMessage = ` (+${valuationPercentageDifference}%)`;
            valuationPercentageDifferenceMessageStyle = { color: 'green', fontSize: "16px" };
        }

        else if (valuationPercentageDifference < 0) {
            valuationPercentageDifferenceMessage = ` (${valuationPercentageDifference}%)`;
            valuationPercentageDifferenceMessageStyle = { color: 'red', fontSize: "16px" };
        }

        else {
            valuationPercentageDifferenceMessage = null;
        }

        return {
            ...data,
            valuationDifference,
            valuationPercentageDifference,
            valuationDifferenceMessage,
            valuationPercentageDifferenceMessage,
            valuationPercentageDifferenceMessageStyle,
        };
    })() : null;

    return (
        <>
            <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                <Card style={{ height: "100%" }}>
                    <Card.Body className="d-flex justify-content-center align-items-center h-100 text-center">
                        <Card.Text as="div">
                            <Row>
                                <p style={{ fontSize: "26px", color: "purple" }}>TOTAL PORTFOLIO VALUE</p>
                            </Row>
                            <Row>
                                <p className="fw-bold" style={{ fontSize: "36px", color: "purple" }}>{data.portfolioValue ? data.portfolioValue.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }) : 'Nil'}
                                    <span style={valuationData.valuationPercentageDifferenceMessageStyle}>
                                        {valuationData.valuationPercentageDifferenceMessage}
                                    </span>
                                </p>
                            </Row>
                            <Row>
                                <p style={{ color: "purple" }}>as at {data.portfolioValueDate ? moment(data.portfolioValueDate).format('Do MMMM YYYY') : moment(today).format('Do MMMM YYYY')}<br />
                                    {valuationData.valuationDifferenceMessage}</p>
                            </Row>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </>
    )
}

export default PortfolioValuationSummaryDetails;